import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import { LoadingSvg } from "../../../utils/SvgIcons";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name, data, loaded) {
  if (data["name"] == "type_user" && loaded) {
    let newData = []
    data["data"].forEach(element => {
      if (element == "user") newData.push("کاربر عادی ،")
      else if (element == "userPremium") newData.push("کاربر ویژه ،")
      if (element.slice(0, 5) == "admin") newData.push("مدیر ،")
    });
    data["data"] = newData
  }
  if (data["name"] == "phoneNumber" && loaded && (data["data"]).toString().slice(0, 5) == "98000") {
    data["data"] = "برای ثبت شماره خود از منوی بالا بر روی گزینه ثبت شماره همراه کلیک کنید"
  }
  return { name, data };
}

export default function ShowLoginInfo(props) {
  const { getAuthUserinfo, authUserinfo } = props;
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const neededData = {
    phoneNumber: "شماره تلفن",
    userName: "نام کاربری",
    type_user: "نوع کاربری",
    presenterCode: "کد معرف خرید پکیج",
    registerCode: "کد معرف ثبت نام در سایت",
  };

  const RecivedLoginInfoData = [authUserinfo];

  // هر مجموعه از دیتا را برای هر جدول درون یک المنت آرایه از listOfTable میریزد
  let listOfTable = RecivedLoginInfoData.map((el, index) => {
    const rowOfTableData = [];
    for (const property in el) {
      // دیتاهایی که در neededData گفته ایم نیاز داریم را جدا می کند
      rowOfTableData[0] = el;
      if (neededData[property]) {
        if (el[property] == "llmmt-Loading") {
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: <LoadingSvg />,
            })
          );
        } else if (el[property] == "llmmt-NoData") {
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: (
                <Tooltip title="اطلاعاتی وارد نشده است">
                  <Typography>-{"------"}</Typography>
                </Tooltip>
              ),
            })
          );
        } else if (el[property] == "llmmt-errorLoading") {
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: (
                <Tooltip title="مشکل در بار گزاری اطلاعات،لطفا دوباره تلاش کنید">
                  <SyncProblemIcon color="error" />
                </Tooltip>
              ),
            })
          );
        } else {
          // دیتاهایی که  بصورت تاریخ هستند - باید خودمان مشخص کنیم-. را تبدیل به تاریخ شمسی میکند
          // if (
          //   property == "createdAt" ||
          //   property == "endingDate" ||
          //   property == "startingDate"
          // ) {
          //   const date = new DateObject({
          //     date: el[property],
          //     calendar: persian,
          //     locale: persian_fa,
          //   });
          //   rowOfTableData.push(
          //     createData(neededData[property], {
          //       name: property,
          //       data: date.format(),
          //     })
          //   );
          // } else if (property == "status") {
          //   console.log("elelelel", el._id, el.status);
          //   allStatusCodeState[el._id] = el.status;
          //   rowOfTableData.push(
          //     createData(neededData[property], {
          //       name: property,
          //       data: el[property],
          //     })
          //   );
          // } else
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: el[property],
            }, true)
          );
        }
      }
    }
    return rowOfTableData;
  });

  // اطلاعات هر سطر را بر میگرداند و در صورت نیاز قبل از برگرداندن تغیراتی روی دیتا انجام می دهیم
  const showRowData = (index, data, oneRow) => {
    const { name, data: content } = data;
    if (
      name == "presenterCode" &&
      authUserinfo.presenterCode == "llmmt-Loading"
    ) {
      return <StyledTableCell align="left">ثبت نشده است</StyledTableCell>;
    } else if (
      name == "registerCode" &&
      authUserinfo.registerCode == "llmmt-Loading"
    ) {
      return <StyledTableCell align="left">ثبت نشده است</StyledTableCell>;
    } else {
      return <StyledTableCell align="left">{content}</StyledTableCell>;
    }
  };

  return (
    <>
      {listOfTable.map((oneRow, index) => (
        <TableContainer
          key={`MainTable-${index}`}
          component={Paper}
          sx={{ mb: 1 }}
        >
          <Table sx={{ minWidth: 10 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell
                  sx={{ width: detectSize600px ? "25%" : "50%" }}
                ></StyledTableCell>
                <StyledTableCell
                  sx={{ width: detectSize600px ? "75%" : "50%" }}
                  align="left"
                ></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {oneRow.map((row, indexRow) =>
                indexRow == 0 ? (
                  ""
                ) : (
                  <StyledTableRow key={row.name}>
                    <StyledTableCell component="th" scope="row">
                      {row.name}
                    </StyledTableCell>
                    {showRowData(index, row.data, oneRow)}
                  </StyledTableRow>
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ))}
    </>
    // <TableContainer component={Paper}>
    //   <Table sx={{ minWidth: 10 }} aria-label="customized table">
    //     <TableHead>
    //       <TableRow>
    //         <StyledTableCell sx={{ width: detectSize600px ? "25%" : "50%" }}>
    //           اطلاعات ورود
    //         </StyledTableCell>
    //         <StyledTableCell
    //           sx={{ width: detectSize600px ? "75%" : "50%" }}
    //           align="left"
    //         ></StyledTableCell>
    //       </TableRow>
    //     </TableHead>
    //     <TableBody>
    //       {rowsTableData.map((row) => (
    //         <StyledTableRow key={row.name}>
    //           <StyledTableCell component="th" scope="row">
    //             {row.name}
    //           </StyledTableCell>
    //           <StyledTableCell align="left">{row.data}</StyledTableCell>
    //         </StyledTableRow>
    //       ))}
    //     </TableBody>
    //   </Table>
    // </TableContainer>
  );
}
